<template>
  <AppLayout>
    <template #middle>
      <InnerContent>
        <UsersContent />
      </InnerContent>
    </template>
    <template #outside>
      <ManualUserImportModal />
      <UsersImportModal />
    </template>
  </AppLayout>
</template>

<script setup lang="ts">
import AppLayout from '@/(routes)/(protected)/(app)/layout.vue'
import InnerContent from '@/features/ui/components/inner-content/inner-content.vue'
import ManualUserImportModal from '@/features/ui/pages/admin/users/manual-user-import-modal/manual-user-import-modal.vue'
import UsersContent from '@/features/ui/pages/admin/users/users-content/users-content.vue'
import UsersImportModal from '@/features/ui/pages/admin/users/users-import-modal/users-import-modal.vue'
</script>
